//Core
import React from "react"

//Components
import InputMask from "react-input-mask"

//Style
import style from "./style.module.scss"

const { Container, Input, Warning, fullWeigth, succes, error } = style

const InputComponents = ({
  type,
  title,
  message,
  valid,
  checked,
  change = () => {},
  placeholder,
  full = false,
  chakedFunc = () => {},
  value,
  hidden,
}) => {
  return (
    <div className={[Container, full ? fullWeigth : " "].join(" ")}>
      {!hidden ? (
          <span>{title}</span>
      ) : '' }
      {type === "phone" ? (
        <InputMask
          className={[
            Input,
            valid ? succes : "",
            checked && !valid ? error : " ",
          ].join(" ")}
          type="tel"
          mask="+38 (099) 999-99-99"
          placeholder={placeholder}
          onChange={({ target: { value } }) => change(value)}
          onBlur={() => chakedFunc()}
        />
      ) : (
        <input
          className={[
            Input,
            valid ? succes : "",
            checked && !valid ? error : " ",
          ].join(" ")}
          type={type}
          placeholder={placeholder}
          onChange={({ target: { value } }) => change(value)}
          onBlur={() => chakedFunc()}
          value={value}
          hidden={hidden} />
      )}
      {checked ? valid ? null : <p className={Warning}>{message}</p> : null}
    </div>
  )
}

export default InputComponents
